/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReservationCapacities200ResponseOneOf1FloorplansInner } from './GetReservationCapacities200ResponseOneOf1FloorplansInner';
import {
    GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSON,
    GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSONTyped,
    GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSON,
    GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSONTyped,
} from './GetReservationCapacities200ResponseOneOf1FloorplansInner';

/**
 * 
 * @export
 * @interface GetReservationCapacities200ResponseOneOf1
 */
export interface GetReservationCapacities200ResponseOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetReservationCapacities200ResponseOneOf1
     */
    type: GetReservationCapacities200ResponseOneOf1TypeEnum;
    /**
     * 
     * @type {Array<GetReservationCapacities200ResponseOneOf1FloorplansInner>}
     * @memberof GetReservationCapacities200ResponseOneOf1
     */
    floorplans: Array<GetReservationCapacities200ResponseOneOf1FloorplansInner>;
}


/**
 * @export
 */
export const GetReservationCapacities200ResponseOneOf1TypeEnum = {
    Floorplan: 'FLOORPLAN'
} as const;
export type GetReservationCapacities200ResponseOneOf1TypeEnum = typeof GetReservationCapacities200ResponseOneOf1TypeEnum[keyof typeof GetReservationCapacities200ResponseOneOf1TypeEnum];


/**
 * Check if a given object implements the GetReservationCapacities200ResponseOneOf1 interface.
 */
export function instanceOfGetReservationCapacities200ResponseOneOf1(value: object): value is GetReservationCapacities200ResponseOneOf1 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('floorplans' in value) || value['floorplans'] === undefined) return false;
    return true;
}

export function GetReservationCapacities200ResponseOneOf1FromJSON(json: any): GetReservationCapacities200ResponseOneOf1 {
    return GetReservationCapacities200ResponseOneOf1FromJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationCapacities200ResponseOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'floorplans': ((json['floorplans'] as Array<any>).map(GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSON)),
    };
}

export function GetReservationCapacities200ResponseOneOf1ToJSON(json: any): GetReservationCapacities200ResponseOneOf1 {
    return GetReservationCapacities200ResponseOneOf1ToJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOf1ToJSONTyped(value?: GetReservationCapacities200ResponseOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'floorplans': ((value['floorplans'] as Array<any>).map(GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSON)),
    };
}

